<div class="rounded-button" [pTooltip]="tooltip().length ? tooltip() : ''" pRipple [class.hoverable]="hoverable()"
    [class.rounded-button--outlined]="outlined() || loading()"
    [class.rounded-button--disabled]="disabled() || loading()" [tooltipPosition]="tooltipPosition()"
    [ngClass]="backgroundColorClassname">
    <span class="cursor-pointer">
        @if(!loading()) {
        <i [class]="icon()"></i>

        }@else {
        <div class="loader">
        </div>
        }
    </span>
</div>